module.exports = __webpack_public_path__ + "img/skirt-front.58ab9bca.jpg";